import { makeGoalCalculator } from "./makeGoalCalculator";

export default makeGoalCalculator({
  key: "child-education",
  title: "Child Education Planning",
  description: "Plan for your child's higher education — what it will cost, and the monthly SIP to get there.",
  labels: {
    presentCost: "Current cost of higher education",
    years: "Years until child begins higher studies",
    currentSavings: "Current savings for higher studies",
  },
  defaults: { presentCost: 25_00_000, yearsToGoal: 15 },
});
